import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const RedirectOnStatus = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const status = queryParams.get('STATUS'); 
    const orderId = queryParams.get('ID'); // ID-ni götürürük

    if (orderId) {
      localStorage.setItem('orderId', orderId); // localStorage-ya yazırıq
    }

    if (!status) return; // STATUS yoxdursa heçnə etmə

    if (status === 'Cancelled') {
      navigate('/make-payment');
    } else if (status === 'FullyPaid') {
      navigate('/success');
    }
  }, [location, navigate]);

  return null; 
};

export default RedirectOnStatus;
